import { useMemo } from "react";
import { Row, Col, Input, Select, Button, Space, Tooltip } from "antd";
import { SearchOutlined, ClearOutlined, EnvironmentOutlined, ProjectOutlined, ShopOutlined } from "@ant-design/icons";
import EntregasExportarButton from "./EntregasExportarButton";
const { Option } = Select;

export default function EntregasFilters({ filters, setFilters, departamentos = [], municipios = [], proyectos = [], productos = [], data = [] }) {
  const handleChange = (field, value) => {
    if (field === "departamento") {
      setFilters(prev => ({
        ...prev,
        departamento: value,
        municipio: null
      }));
      return;
    }
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));

  };

  const municipiosFiltrados = useMemo(() => {
    if (!filters.departamento) return [];
    return municipios.filter(
      (m) => Number(m.oid_depto) === Number(filters.departamento)
    );
  }, [municipios, filters.departamento]);

  const clearFilters = () => {
    setFilters({
      search: "",
      proyecto: null,
      departamento: null,
      municipio: null,
      producto: null,
      tipo_entrega: null
    });
  };

  return (
    <div>
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} md={12} lg={4}>
          <Tooltip title="Buscar por participante o producto">
            <Input
              allowClear
              placeholder="Buscar..."
              prefix={<SearchOutlined />}
              value={filters.search}
              onChange={(e) =>
                handleChange("search", e.target.value)
              }
            />
          </Tooltip>
        </Col>
        <Col xs={24} md={12} lg={5}>
          <Select
            allowClear
            showSearch
            placeholder="Proyecto"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.proyecto}
            suffixIcon={<ProjectOutlined />}
            onChange={(v) =>
              handleChange("proyecto", v)
            }
          >
            {proyectos.map((p) => (

              <Option key={p.oid} value={p.oid}>
                {p.codigo} - {p.proyecto}
              </Option>

            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={4}>
          <Select
            allowClear
            showSearch
            placeholder="Departamento"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.departamento}
            suffixIcon={<EnvironmentOutlined />}
            onChange={(v) =>
              handleChange("departamento", v)
            }
          >
            {departamentos.map((d) => (
              <Option key={d.oid} value={d.oid}>
                {d.departamento}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={4}>
          <Select
            allowClear
            showSearch
            placeholder={
              filters.departamento
                ? "Municipio"
                : "Seleccione departamento primero"
            } disabled={!filters.departamento}
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={filters.municipio}
            suffixIcon={<EnvironmentOutlined />}
            onChange={(v) =>
              handleChange("municipio", v)
            }
          >
            {municipiosFiltrados.map((m) => (
              <Option key={m.oid} value={m.oid}>
                {m.municipio}
              </Option>

            ))}
          </Select>
        </Col>
        <Col xs={24} md={12} lg={3}>
          <Select
            allowClear
            placeholder="Tipo entrega"
            style={{ width: "100%" }}
            suffixIcon={<ShopOutlined />}
            value={filters.tipo_entrega}
            onChange={(v) =>
              handleChange("tipo_entrega", v)
            }
          >
            <Option value={1}>Participante</Option>
            <Option value={2}>Organización</Option>
          </Select>
        </Col>
        <Col xs={24} md={12} lg={3}>
          <Space>
            <Tooltip title="Restablecer filtros">
              <Button
                icon={<ClearOutlined />}
                onClick={clearFilters}
              >
              </Button>
            </Tooltip>
            <EntregasExportarButton data={data} />
          </Space>
        </Col>
      </Row>
    </div>
  );
}